import {retainConstants} from "../_constants";
import {retainService} from "../_services";
import {SnackBar} from "../components/common";
import {Auth} from "../components/Authorization";
import {alertMessages} from "../_constants";
import _ from "lodash";

function getCompanyRetainCampaigns() {
    const request = () => ({
        type: retainConstants.GET_COMPANY_RETAIN_CAMPAIGNS_REQUEST
    });
    const success = (response) => ({
        type: retainConstants.GET_COMPANY_RETAIN_CAMPAIGNS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: retainConstants.GET_COMPANY_RETAIN_CAMPAIGNS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        retainService.getCompanyRetainCampaigns()
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401){
                Auth.processLogout();
                return;
            }
            dispatch(failure(error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

function getCompanyRetainMetrics(params) {
    const request = () => ({
        type: retainConstants.GET_COMPANY_RETAIN_METRICS_REQUEST
    });
    const success = (response) => ({
        type: retainConstants.GET_COMPANY_RETAIN_METRICS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: retainConstants.GET_COMPANY_RETAIN_METRICS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        retainService.getCompanyRetainMetrics(params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
            if(_.get(error, 'response.status') === 401){
                Auth.processLogout();
                return;
            }
            dispatch(failure(error));
            SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

function getOrganizationRetainCampaigns(organizationId, params) {
    const request = () => ({
        type: retainConstants.GET_ORGANIZATION_RETAIN_CAMPAIGNS_REQUEST
    });
    const success = (response) => ({
        type: retainConstants.GET_ORGANIZATION_RETAIN_CAMPAIGNS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: retainConstants.GET_ORGANIZATION_RETAIN_CAMPAIGNS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        retainService.getOrganizationRetainCampaigns(organizationId, params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
                if(_.get(error, 'response.status') === 401){
                    Auth.processLogout();
                    return;
                }
                dispatch(failure(error));
                SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

function getOrganizationRetainMetrics(organizationId, params) {
    const request = () => ({
        type: retainConstants.GET_ORGANIZATION_RETAIN_METRICS_REQUEST
    });
    const success = (response) => ({
        type: retainConstants.GET_ORGANIZATION_RETAIN_METRICS_SUCCESS,
        payload: { ...response }
    });
    const failure = (error) => ({
        type: retainConstants.GET_ORGANIZATION_RETAIN_METRICS_FAILURE, error,
        payload: { error }
    });

    return dispatch => {
        dispatch(request());
        retainService.getOrganizationRetainMetrics(organizationId, params)
            .then(response => {
                dispatch(success(response.data));
            }).catch((error) => {
                if(_.get(error, 'response.status') === 401){
                    Auth.processLogout();
                    return;
                }
                dispatch(failure(error));
                SnackBar.showMessage(alertMessages.GENERIC_ERROR);
        })
    }
}

export const retainActions = {
    getCompanyRetainCampaigns,
    getCompanyRetainMetrics,
    getOrganizationRetainCampaigns,
    getOrganizationRetainMetrics
}